import getCharts from '../getCharts'
import { PatientPersonalHistoryCRUD } from '../../constants/api.config'

export default async function getPatientPersonalHistory(mode = "", patientID = "", historyType = "", pdate = "", history = '', id = "-1") {
    try {
        const payload = { patientID, mode, historyType, pdate, history, id }
        const res = await getCharts(PatientPersonalHistoryCRUD, payload)
        return res.data
    } catch (error) {
        return error
    }
}
